/**
 * atomberg-blog-load-more.js
 * ───────────────────────────
 * Manual "Read More" pagination for the blog list. Horizon's PaginatedList
 * only auto-loads via IntersectionObserver sentinels with no public API for
 * a click trigger, so this fetches the next page itself via the Section
 * Rendering API (?sections=<id>) and appends the returned cards. The button
 * carries its own next-page URL forward from each response and removes
 * itself on the last page.
 */
(function () {
  /** @type {any} */
  var w = window;
  if (w._atombergBlogLoadMoreInit) return;
  w._atombergBlogLoadMoreInit = true;

  document.addEventListener('click', function (event) {
    var target = /** @type {HTMLElement} */ (event.target);
    var button = /** @type {HTMLButtonElement|null} */ (target.closest('[data-blog-load-more]'));
    if (!button) return;

    var nextUrl = button.getAttribute('data-next-url');
    var sectionId = button.getAttribute('data-section-id');
    var grid = document.querySelector('.atomberg-blog-list__grid');
    if (!nextUrl || !sectionId || !grid) return;

    var gridEl = grid;
    var btn = button;
    var sectionKey = sectionId;
    btn.disabled = true;

    var fetchUrl = new URL(nextUrl, window.location.origin);
    fetchUrl.searchParams.set('sections', sectionKey);

    fetch(fetchUrl.toString())
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var html = data[sectionKey];
        if (!html) throw new Error('empty section response');

        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('.atomberg-blog-list__grid > li').forEach(function (card) {
          gridEl.appendChild(document.importNode(card, true));
        });

        var nextButton = doc.querySelector('[data-blog-load-more]');
        var newNextUrl = nextButton ? nextButton.getAttribute('data-next-url') : null;
        if (newNextUrl) {
          btn.setAttribute('data-next-url', newNextUrl);
          btn.disabled = false;
        } else {
          var wrapper = btn.closest('.atomberg-blog-list__more');
          if (wrapper) wrapper.remove();
        }
      })
      .catch(function () {
        // network/parse failure: re-enable so the reader can just retry
        btn.disabled = false;
      });
  });
})();
